module.exports = __webpack_public_path__ + "img/collection-weddingRingsCarbon@2x.5da86be.webp";